import './App.css';
import {createTheme, ThemeProvider} from "@mui/material/styles";
import Box from "@mui/material/Box";
import * as React from "react";
import {RouterProvider} from "react-router-dom";
import router from "./routes/router";
import Roboto from "@fontsource/roboto"

const theme = createTheme({
    typography: {
        fontFamily: 'Roboto',
    },
    palette: {
        mode: 'dark',
        primary: {
            main: '#4ca1a1'
        },
        text: {
            primary: '#ffffff'
        }
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: `
            @font-face {
          font-family: 'Roboto';
          font-style: normal;
          font-display: swap;
          font-weight: 400;
          src: local('Roboto'), local('Roboto-Regular'), url(${Roboto}) format('woff2');
          unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
        }`
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    maxWidth: '345px',
                    border: "1px solid #282828",
                },
            },
        }
    }
});

function App() {
    return (
        <div className="App">
            <ThemeProvider theme={theme}>
                <Box
                    sx={{
                        marginTop: 2,
                        padding: 3,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <RouterProvider router={router}/>
                </Box>
            </ThemeProvider>
        </div>
    );
}

export default App;
